// Bugsnag
export const BUGSNAG_NOTIFY_URL = 'https://bugsnag-notify.aspendental.com';
export const BUGSNAG_SESSIONS_URL = 'https://bugsnag-sessions.aspendental.com';
export const BUGSNAG_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY as string;

export const contactNumber = '8889788625';

export enum TagTheme {
	AspenDental = 'aspendental',
	AzPetVet = 'azPetVet',
	TeamTag = 'teamTag',
	WellNow = 'wellnow',
	Chapter = 'chapter',
	ClearChoice = 'clearchoice',
}

export enum SubmitAppointmentErrorCode {
	CONSULT_SCHEDULED = 'consult_scheduled',
	NO_APPOINTMENTS = 'no_appointments',
}

// names based on this information: https://aspendent.atlassian.net/browse/DCP-3057
export enum FormIdMappings {
	formID = '4d2ed60e-6463-11ef-bff5-0192d98a2726',
	// form with 3 dental questions
	formID3DentalQuestions = 'ca4c8298-befa-11ef-8f60-45af9e09548c',
}

export const DENTURE_OR_PARTIAL_DENTURE_SHORT_NAME = 'denture';
export const DENTAL_IMPLANT_SHORT_NAME = 'implant';
export const GOOGLE_RESERVE_PARTNER_ID = 20002677;

export const CACHE_CONTROL_NO_CACHE = 'no-cache, no-store, must-revalidate';
